import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminDocuments() {
  const [docs, setD] = useState([]);
  const load = () => api.get("/admin/documents").then(r => setD(r.data));
  useEffect(() => { load(); }, []);
  const del = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/documents/${id}`);
    toast.success("Deleted");
    load();
  };
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <span className="px-2 py-1 rounded-md bg-red-500/20 border border-red-500/40 text-red-300 text-[10px] tracking-widest uppercase">ADMIN</span>
      <h1 className="mt-2 text-3xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Documents</h1>
      <div className="mt-6 glass-strong rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="text-xs uppercase tracking-widest text-zinc-400 bg-white/[0.02]">
            <tr><th className="text-left px-5 py-3">File</th><th className="text-left px-3 py-3">User</th><th className="text-left px-3 py-3">Type</th><th className="text-left px-3 py-3">Words</th><th className="text-left px-3 py-3">Rounds</th><th className="text-left px-3 py-3">AI%</th><th className="text-left px-3 py-3">Status</th><th className="text-right px-5 py-3"></th></tr>
          </thead>
          <tbody>
            {docs.map(d => (
              <tr key={d.id} className="border-t border-white/[0.05]">
                <td className="px-5 py-3 truncate max-w-[200px]">{d.fileName}</td>
                <td className="px-3 py-3 text-zinc-400">{d.userEmail}</td>
                <td className="px-3 py-3 uppercase text-xs">{d.fileType}</td>
                <td className="px-3 py-3">{d.originalWordCount}</td>
                <td className="px-3 py-3">{(d.rounds||[]).length}</td>
                <td className="px-3 py-3">{d.finalAiPercentage ?? "—"}%</td>
                <td className="px-3 py-3 text-xs">{d.status}</td>
                <td className="px-5 py-3 text-right">
                  <button onClick={() => del(d.id)} className="p-1.5 rounded hover:bg-red-500/20 text-red-400" data-testid={`admin-del-doc-${d.id}`}><Trash2 size={14}/></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
